import { render, staticRenderFns } from "./qesg-dash-chart-card.vue?vue&type=template&id=bf9795b2&"
import script from "./qesg-dash-chart-card.vue?vue&type=script&lang=js&"
export * from "./qesg-dash-chart-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports